export default "__VITE_ASSET__5bb134a8__"